import { forwardRef } from 'react';
import { CaretLeftIcon, XIcon } from '@phosphor-icons/react';
import { DrawerDescription, DrawerTitle } from '@/components/ui/drawer';
import { IconButton, StepProgress } from './kit';

/** Bottom-sheet header: optional back, bold title, a quiet subtitle (e.g. «Шаг 2 из 4»), close, progress. */
export const SheetHeader = forwardRef<
  HTMLDivElement,
  {
    title: string;
    subtitle?: string | null;
    description: string;
    progress?: { step: number; total: number } | null;
    onClose: () => void;
    closeDisabled?: boolean;
    onBack?: (() => void) | null;
  }
>(function SheetHeader({ title, subtitle, description, progress, onClose, closeDisabled, onBack }, titleRef) {
  return (
    <div className="ui-sheet-head">
      <div className="ui-row" style={{ alignItems: 'center', ['--ui-gap' as string]: 'var(--spacing-2)' }}>
        {onBack ? <IconButton icon={CaretLeftIcon} label="Назад" onClick={onBack} disabled={closeDisabled} /> : null}
        <div className="ui-stack ui-grow" style={{ ['--ui-gap' as string]: '2px' }}>
          <div ref={titleRef} tabIndex={-1} style={{ outline: 'none' }}>
            <DrawerTitle className="ui-sheet-title">{title}</DrawerTitle>
          </div>
          {subtitle ? (
            <DrawerDescription className="ui-caption">{subtitle}</DrawerDescription>
          ) : (
            <DrawerDescription className="visually-hidden">{description}</DrawerDescription>
          )}
        </div>
        <IconButton icon={XIcon} label="Закрыть" onClick={onClose} disabled={closeDisabled} />
      </div>
      {progress ? <StepProgress step={progress.step} total={progress.total} /> : null}
    </div>
  );
});
